import { render, staticRenderFns } from "./StockTransferView.vue?vue&type=template&id=8328f568&scoped=true&"
import script from "./StockTransferView.vue?vue&type=script&lang=js&"
export * from "./StockTransferView.vue?vue&type=script&lang=js&"
import style0 from "./StockTransferView.vue?vue&type=style&index=0&id=8328f568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8328f568",
  null
  
)

export default component.exports